import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import InfoCards from 'components/InfoCards'
import LeftArrowIcon from 'components/icons/LeftArrowIcon'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import RolesInfoTable from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable'
import {
  Address,
  CardRow,
  JobDetailsSpan,
  LeftArrowSpan,
  Name,
  NameAdd,
  RoleSpan,
  SectionWrapper,
  TopRoleSection,
} from 'modules/Dashboard/Partials/DashboardRoles/Style/style'
import { getDashboardRoleList } from 'modules/Dashboard/actions'
import StatusTabs from 'modules/Roles/Partials/StatusTabs'
import { corporateAboutUs, getCities } from 'modules/Roles/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { COLORS } from 'theme'

const DashboardRoles = ({
  rolesList,
  singleRoleDetails,
  getRolesListData,
  updateRoleData,
  setJobId,
  getJobDetails,
  instituteCampusId,
  citiesList,
  corporateDetails,
  updatePageNum,
  pageNum,
}) => {
  const params = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const occurrenceFromParams = searchParams.get('occurrence') ?? ''

  const [cardsData, setCardsData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectionType, setSelectionType] = useState('All')
  const [selectionValue, setSelectionValue] = useState('')
  const [urlQuery, setUrlQuery] = useState('')
  const [currentPage, setCurrentPage] = useState(0)
  const [sortQuery, setSortQuery] = useState('')
  const corpID = params?.corpID
  const [search, setSearch] = useState('')
  const [filterQuery, setFilterQuery] = useState('')
  const dashboardRoleList = useSelector(
    state => state?.dashboard?.dashboardRoleList
  )
  const corporateData = useSelector(state => state?.roles?.corporateDetails)
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  useEffect(() => {
    dispatch(
      getDashboardRoleList({
        corpID,
        currentPage,
        selectionValue,
        search,
        filterQuery,
        sortBy,
        orderBy,
        setLoading,
        occurrenceFromParams,
      })
    )
  }, [
    params.corpID,
    currentPage,
    selectionValue,
    search,
    filterQuery,
    sortBy,
    orderBy,
  ])
  useEffect(() => {
    dispatch(corporateAboutUs(corpID))
  }, [params.corpID])

  useEffect(() => {
    const cardData = [
      {
        key: 1,
        icon: <UserDefaultIcon />,
        text: 'Total Roles',
        value: dashboardRoleList?.roleCount,
        isSelected: false,
      },
      {
        key: 2,
        icon: <UserDefaultIcon />,
        text: 'Roles active',
        value: dashboardRoleList?.activeRolecount,
        isSelected: false,
      },
      {
        key: 3,
        icon: <UserDefaultIcon />,
        text: 'Students applied / Active',
        value: dashboardRoleList?.uniqueAppliedStudentCount,
        isSelected: false,
      },
      {
        key: 4,
        icon: <UserDefaultIcon />,
        text: 'Corporate actively hiring',
        value: dashboardRoleList?.activelyHriringCorporateCount,
        isSelected: false,
      },
    ]
    setCardsData(cardData)
  }, [dashboardRoleList])

  const changeState = type => {
    setSelectionType(type)
    if (type == 'All') {
      setSelectionValue('')
    } else if (type == 'AcceptedRoles') {
      setSelectionValue('status=1')
    } else {
      setSelectionValue('saved=1')
    }
    setCurrentPage(0)
  }

  const onFilerChange = query => {
    setUrlQuery(query)
  }
  const onSortingChanged = query => {
    setSortQuery(query)
  }
  const onAcceptOrRejectClick = data => {
    setSelecredRole(data)
    setnewAcceptOrRejectDrawer(true)
  }

  const handleArrow = () => {
    navigate('/dashboard')
  }
  return (
    <SectionWrapper column>
      <TopRoleSection>
        <LeftArrowSpan onClick={handleArrow}>
          <LeftArrowIcon />
        </LeftArrowSpan>
        <RoleSpan onClick={handleArrow}>Corporate List</RoleSpan>
        <JobDetailsSpan>/</JobDetailsSpan>
        <RoleSpan onClick={handleArrow}>Roles</RoleSpan>
        <JobDetailsSpan>/</JobDetailsSpan>
        <JobDetailsSpan> View Role Details</JobDetailsSpan>
      </TopRoleSection>

      <Flex centerVertically style={{ padding: '20px' }}>
        {corporateData?.logo ? (
          <Avatar src={corporateData?.logo} />
        ) : (
          <Avatar
            background
            size={42}
            IconName={corporateData?.name?.split('')?.[0] || 'H'}
            font={18}
          />
        )}
        <NameAdd column flexStart>
          <Address>{corporateData?.name}</Address>
          <Name>{corporateData?.industry}</Name>
        </NameAdd>
      </Flex>

      <CardRow spaceBetween>
        {cardsData?.map(card => (
          <InfoCards
            padding={'20px'}
            width={'25%'}
            icon={card?.icon}
            text={card?.text}
            value={card?.value}
            background={card?.isSelected ? COLORS.BLUE_T_50 : COLORS.BLUE_T_95}
            isSelected={card?.isSelected}
          />
        ))}
      </CardRow>

      <StatusTabs
        selected={selectionType}
        selectedType={type => {
          changeState(type)
        }}
      />
      <br></br>
      <RolesInfoTable
        rolesList={rolesList}
        dashboardRoleList={dashboardRoleList}
        search={search}
        setSearch={setSearch}
        setFilterQuery={setFilterQuery}
        sortBy={sortBy}
        setSortBy={setSortBy}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        updateRoleData={updateRoleData}
        setJobId={setJobId}
        setUrl={onFilerChange}
        currentUrl={urlQuery}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        getJobDetails={getJobDetails}
        corporateAboutUs={corporateAboutUs}
        corporateDetails={corporateDetails}
        onAcceptOrRejectClick={onAcceptOrRejectClick}
        onSortValueChanged={onSortingChanged}
        sortQuery={sortQuery}
        loading={loading}
        citiesList={citiesList}
        getCities={getCities}
      />
    </SectionWrapper>
  )
}
export default DashboardRoles
